<div class="hero">
  <div class="hero-overlay">
  </div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">Contact us</span><br>
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4">
  <div class="row mt-4 mb-3">
    <div class="col-12 col-lg-6 offset-lg-3">
      <p [innerHTML]="contactUsDescriptionHtml"></p>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 col-lg-6 offset-lg-3">
      <h4 class="py-2">Contact details</h4>
      <p>
        <strong>Tel:</strong>
        {{ companyPhoneNumber }}
      </p>
      <p *ngIf="userService.isUserStoredInServicePremium() || userService.isUserStoredInServiceBasicPlus()">
        <strong>Missing pet line:</strong>
        {{ lostPetPhoneNumber }}
      </p>
      <p>
        <strong>Email:</strong>
        {{ email }}
      </p>
      <p>
        <strong>Address:</strong>
        {{ address }}
      </p>
    </div>
  </div>
</div>
